document.addEventListener('DOMContentLoaded', () => {
  const endpoint = 'https://sdduubuztedcorotoqmc.supabase.co/functions/v1/search-products';
  const searchPageUrl = '/pages/ai-search';

  const forms = document.querySelectorAll('.custom-header-search__form');
  let factoryOrderText = 'Available to order from factory';

  forms.forEach((form) => {
    const input = form.querySelector('.custom-header-search__input');
    const results = form.querySelector('.ai-search-results');
    const enzoLink = form.querySelector('.custom-header-search__ai');

    if (!input || !results) return;

    // Same locale key/wording as content.product_badge_factory_order site-wide.
    if (form.dataset.factoryOrderText) {
      factoryOrderText = form.dataset.factoryOrderText;
    }

    let timer;

    // Carry typed text over as Enzo's first message. If the bar is empty,
    // don't intercept — the plain href already opens Enzo with the greeting.
    if (enzoLink) {
      enzoLink.addEventListener('click', (event) => {
        const query = input.value.trim();
        if (!query) return;

        event.preventDefault();
        window.location.href = `${searchPageUrl}?enzo=${encodeURIComponent(query)}#chat`;
      });
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const query = input.value.trim();
      if (query.length < 2) return;

      trackSearch(query);
      window.location.href = `${searchPageUrl}?q=${encodeURIComponent(query)}`;
    });

    // GA4 tracking fires only on an explicit completed search (Enter/submit
    // above, or clicking a predictive result here) — never from the debounced
    // preview fetch below, so partial/in-progress queries never reach GA4.
    results.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      trackSearch(input.value.trim());
    });

    input.addEventListener('input', () => {
      clearTimeout(timer);

      const query = input.value.trim();

      if (query.length < 3) {
        results.innerHTML = '';
        results.classList.remove('is-active');
        return;
      }

      timer = setTimeout(() => previewSearch(query, results), 450);
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) {
        results.innerHTML = '';
        results.classList.remove('is-active');
      }
    });
  });

  function trackSearch(query) {
    if (!query) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_search_results',
      search_term: query
    });
  }

  async function previewSearch(query, results) {
    results.classList.add('is-active');
    results.innerHTML = '<div class="ai-search-message">Searching...</div>';

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query,
          limit: 5,
          threshold: getThreshold(query)
        })
      });

      const data = await response.json();
      const pages = Array.isArray(data.pages) ? data.pages : [];

      if ((!data.results || !data.results.length) && !pages.length) {
        results.innerHTML = `
          <div class="ai-search-message">
            No quick matches found.
            <br>
            <a class="ai-search-view-all" href="${searchPageUrl}?q=${encodeURIComponent(query)}">
              Search all products for “${escapeHtml(query)}”
            </a>
          </div>
        `;
        return;
      }

      const productsHtml = (data.results || []).map(renderProduct).join('');
      const pagesHtml = pages.length ? renderPagesBlock(pages) : '';

      results.innerHTML = `
        ${productsHtml}
        ${pagesHtml}
        <a class="ai-search-view-all" href="${searchPageUrl}?q=${encodeURIComponent(query)}">
          View all results for “${escapeHtml(query)}”
        </a>
      `;
    } catch (error) {
      console.error('AI SEARCH ERROR', error);
      results.innerHTML = '<div class="ai-search-message">Search unavailable</div>';
    }
  }

  function getThreshold(query) {
    if (query.length <= 5) return 0.18;
    if (query.split(/\s+/).length === 1) return 0.2;
    return 0.3;
  }

  function renderProduct(product) {
    const title = escapeHtml(product.title || '');
    const handle = escapeHtml(product.handle || '');
    const image = product.featured_image_url && product.featured_image_url !== 'null'
      ? product.featured_image_url
      : '';

    const price = product.price_min === 0
      ? factoryOrderText
      : product.price_min
        ? `£${Number(product.price_min).toFixed(2)}`
        : '';

    return `
      <a class="ai-search-item" href="/products/${handle}">
        <div class="ai-search-thumb">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${title}" loading="lazy">`
              : `<div class="ai-search-no-image"></div>`
          }
        </div>

        <div class="ai-search-info">
          <div class="ai-search-title">${title}</div>
          ${price ? `<div class="ai-search-price">${price}</div>` : ''}
        </div>
      </a>
    `;
  }

  // Pages ("About", "FAQ", delivery/returns guides, ...) — a lightweight,
  // text-only block under the product results, same look everywhere the
  // pages RPC already appears (see the classic-grid ai-search.liquid).
  function renderPagesBlock(pages) {
    const items = pages.map(renderPageItem).join('');
    return `
      <div class="ai-search-pages-label">Pages</div>
      ${items}
    `;
  }

  function renderPageItem(page) {
    const title = escapeHtml(page.title || '');
    const url = escapeHtml(page.url || (page.handle ? `/pages/${page.handle}` : searchPageUrl));

    return `
      <a class="ai-search-page-item" href="${url}">
        <div class="ai-search-title">${title}</div>
      </a>
    `;
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
});
